import React, { useEffect, useState } from 'react'

import { UserContext } from 'contexts'
import { parseISO } from 'date-fns'
import { User } from 'interfaces'

type UserProviderProps = {
  children: React.ReactNode
}

const initialState = {
  auth: false,
  auth_type: '',
  fetched: false,
  first_name: '',
  last_name: '',
  feide_id: '',
  person_id: '',
  sponsor_id: '',
  email: '',
  mobile_phone: '',
  fnr: '',
  national_id_card: '',
  passport: '',
  roles: [],
  consents: [],
  registration_completed_date: null,
  is_staff: false,
  sponsor_for_ous: [],
  verifier_for_ous: [],
}

function UserProvider(props: UserProviderProps) {
  const { children } = props

  const [user, setUser] = useState<User>(initialState)

  const getUserInfo = async () => {
    try {
      const response = await fetch('/api/ui/v1/userinfo/')
      const data = await response.json()

      if (response.ok) {
        setUser({
          auth: true,
          auth_type: data.auth_type,
          fetched: true,
          first_name: data.first_name,
          last_name: data.last_name,
          feide_id: data.feide_id,
          person_id: data.person_id,
          sponsor_id: data.sponsor_id,
          email: data.email,
          mobile_phone: data.mobile_phone,
          fnr: data.fnr,
          national_id_card: data.national_id_card,
          passport: data.passport,
          roles: data.roles,
          consents: data.consents,
          registration_completed_date: data.registration_completed_date
            ? parseISO(data.registration_completed_date)
            : null,
          is_staff: data.is_staff,
          sponsor_for_ous: data.sponsor_for_ous,
          verifier_for_ous: data.verifier_for_ous,
        })
      } else {
        setUser({ ...initialState, fetched: true })
      }
    } catch (error) {
      setUser({ ...initialState, fetched: true })
    }
  }

  const fetchUserInfo = () => {
    if (!user.auth) {
      getUserInfo()
    }
  }

  useEffect(() => {
    if (!user.auth && !user.fetched) {
      getUserInfo()
    }
  }, [])

  const clearUserInfo = () => {
    setUser(initialState)
  }

  return (
    <UserContext.Provider
      value={{ user, fetchUserInfo, clearUserInfo, getUserInfo }}
    >
      {children}
    </UserContext.Provider>
  )
}

export default UserProvider
